export const BANNER_NAME = 'COOKIE_CONSENT_BANNER';

export const BANNER_HEIGHT = 105;
export const MIN_BANNER_WIDTH = 320;
